var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 6,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0006 11.875C26.5841 11.875 28.0183 12.5171 29.0557 13.5545C30.093 14.5919 30.7351 16.0263 30.7351 17.6095C30.7351 19.1908 30.093 20.6246 29.0555 21.663L29.0527 21.6657C28.0144 22.7027 26.5817 23.3444 25.0007 23.3444C23.4194 23.3444 21.986 22.7023 20.9476 21.6648L20.9449 21.662C19.9079 20.6237 19.2661 19.1906 19.2661 17.6096C19.2661 16.0261 19.9082 14.5919 20.9456 13.5545C21.983 12.5172 23.4174 11.875 25.0006 11.875Z",
    fill: "#B5B5C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5628 25.885H28.4392C30.9313 25.885 33.1974 26.9048 34.8389 28.5465C36.4807 30.1886 37.5 32.4542 37.5 34.9467C37.5 35.8404 37.1348 36.6528 36.5465 37.241C35.9583 37.8293 35.146 38.1945 34.2526 38.1945H15.7478C14.8544 38.1945 14.0417 37.8293 13.4535 37.241L13.4304 37.216C12.8563 36.6297 12.5 35.8276 12.5 34.9471C12.5 32.4546 13.5194 30.1885 15.1617 28.5464C16.8034 26.9046 19.0702 25.885 21.5628 25.885Z",
    fill: "#B5B5C3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.f8f295e19ac8760f6d50e616868cc631.svg";
export { ForwardRef as ReactComponent };